/* Presentation only: the native form owns its fields, validation and submission.
 * No hashed app classes or field reparenting: an app update can fall back to one column.
 */
if (!customElements.get('professional-application')) {
  customElements.define('professional-application', class extends HTMLElement {
    connectedCallback() {
      let attempts = 0;
      const enhance = () => {
        const root = this.querySelector('shopify-forms-embed')?.shadowRoot;
        if (!root) return false;
        if (!root.querySelector('[data-porchet-form-style]')) {
          const style = document.createElement('style');
          style.dataset.porchetFormStyle = '';
          style.textContent = `
            section:has(~ form) > h2 { display: none; }
            section:has(~ form) { padding-bottom: 0 !important; margin: 5px 0 18px !important; }
            form { display: grid !important; grid-template-columns: minmax(0, 1fr); gap: 14px !important; }
            form > * { min-width: 0; }
            form div:has(> input:not([type="file"])), form div:has(> textarea) { display: flex !important; flex-direction: column; }
            form label:has(+ input), form input + label, form textarea + label {
              position: static !important; transform: none !important; order: -1; margin: 0 0 7px !important;
              font: 400 13px/1.35 Arial, sans-serif !important; color: #343539; text-align: left; width: auto !important;
            }
            form input:not([type="file"]), form textarea { box-sizing: border-box; width: 100%; font-size: 16px; padding: 12px !important; }
            form input:not([type="file"]) { min-height: 44px; }
            form textarea { min-height: 76px; }
            form div:has(> textarea)::before { content: none !important; }
            form .phone-country-selector { align-self: end; }
            form .phone-country-selector button { min-height: 44px; box-sizing: border-box; }
            form > button[type="submit"] { margin-top: 6px; min-height: 48px; box-sizing: border-box; width: 100%; letter-spacing: .3px; }
            @media (min-width: 1100px) {
              form:has(> div > #first_name):has(> div > #last_name) { grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 18px !important; }
              form > * { grid-column: 1 / -1 !important; }
              form > div:has(> #first_name), form > div:has(> #last_name), form > div:has(> #email), form > div:has(#phone_number) { grid-column: auto !important; }
            }
          `;
          root.appendChild(style);
        }
        return true;
      };
      if (enhance()) return;
      this.formTimer = setInterval(() => {
        if (enhance() || ++attempts >= 150) clearInterval(this.formTimer);
      }, 100);
    }
    disconnectedCallback() { clearInterval(this.formTimer); }
  });
}
